import main from './main';
import login from './login';
import loader from './loader';

export default {
    main,
    login,
    loader
}